import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { TemplateFifteenPDFSection, TemplateFifteenSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateFifteenSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && (enableHighlight || enableMistakeHighlight) ? (
          <ResumePDFHighlightableText
            text={summary}
            section="profile"
            itemIndex={null}
            style={{ color: themeColor }}
            enableMistakeHighlight={enableMistakeHighlight}
          />
        )
         : (
          <ResumePDFText themeColor={themeColor}>{summary}</ResumePDFText>
         )
        }
      </View>
    </TemplateFifteenSection>
  );
};
